import React from "react";
import { Modal } from "react-bootstrap";
import SaveQuoteAnalysis from "./SaveQuoteAnalysis";

export default function SaveQuote(props) {
    const closeModal = () => {
        props.fields.setModalSaveQuoteIsOpen(false);
        props.fields.setErrorMessage({ status: '', message: '' });
    };

    const onSubmit = () => {
        props.onSubmit();
    };

    return (
        <Modal 
            show={props.fields.modalSaveQuoteIsOpen} 
            className="save-term-model icon-bg" 
            onHide={() => closeModal()}
            size="md">
            <Modal.Header className="d-flex justify-content-center" closeButton>
                <Modal.Title className="modal-title">{props.fields.errorMessage.status === "success" ? props.saveMessage && props.saveMessage.success.title : props.saveMessage && props.saveMessage.initial.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <SaveQuoteAnalysis 
                    setEmailPrefill={(e) => {props.setEmailPrefill(e)}} 
                    fields={props.fields} 
                    saveMessage={props.saveMessage} 
                    saveQuoteData={props.saveQuoteData}
                    setQuoteSaved={props.setQuoteSaved}
                    isQuoteSaved={props.isQuoteSaved}
                    onSubmit={onSubmit}
                    handleContactChange={(e) => props.handleContactChange(e)}/>
            </Modal.Body>
            <Modal.Footer>
            </Modal.Footer>
        </Modal>
    );
}